/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FrequencyViewModel } from './FrequencyViewModel'; 

export function getVisitPlanForCertificationPeriodOptions(certificationPeriodId: string, disciplineId: number, onSuccess?: (result: FrequencyViewModel[]) => void) {
	return queryOptions({
		queryKey: ['visit-plan-for-certification-period', certificationPeriodId, disciplineId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/frequencies/queries/getvisitplanforcertificationperiod/' + certificationPeriodId + '/' + disciplineId;
			const resp = await axios.get<FrequencyViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(certificationPeriodId) && Boolean(disciplineId)
	});
}